module.exports = __webpack_public_path__ + "img/meiwen.7466c5d6.png";